module.exports = __webpack_public_path__ + "static/media/iso-icon.45e0dca7.svg";